import { environment } from '@environments/environment';
import { TRON_NETWORK_TYPE } from '../models/network-metadata.model';

const EXPLORERS = [
  { type: TRON_NETWORK_TYPE, names: ['Tron', 'Tron Nile'], txUrl: (hash: string) => `${environment.TRONSCAN_BASE_URL}/#/transaction/${hash}` },
  { type: 60, names: ['Ethereum', 'Ethereum Sepolia'], txUrl: (hash: string) => `${environment.ETHERSCAN_BASE_URL}/tx/${hash}` },
  { type: 9006, names: ['BNB Smart Chain', 'BSC Testnet'], txUrl: (hash: string) => `${environment.BSCSCAN_BASE_URL}/tx/${hash}` },
];

export function getTransactionExplorerUrl(
  network: number | string | null | undefined,
  hash: string | null | undefined,
): string | null {
  if (!hash) return null;
  const explorer = EXPLORERS.find((e) => e.type === network || (typeof network === 'string' && e.names.includes(network)));
  return explorer ? explorer.txUrl(hash) : null;
}
